import styles from "./Title.module.css";

function Title({ titleText }) {
  return (
    <div className={styles.title}>
      <div className={styles.line}></div>
      <h2>{titleText}</h2>
      <div className={styles.line}></div>
    </div>
  );
}

export default Title;
